import { apiClient } from "./client";

export const rolesApi = {
  /**
   * Fetches the full permission matrix for the specified agency.
   * Returns: { roles: [], permissions: [], groups: [], matrix: {} }
   */
  getPermissions: async (agencyId) => {
    const response = await apiClient.get(`/auth/roles/permissions/?agency_id=${agencyId}`);
    return response.data;
  },

  /**
   * Bulk-updates permissions for a single role.
   * payload: { role: "caregiver", permissions: ["directory.clients.view", ...] }
   */
  updateRolePermissions: async (agencyId, role, permissions) => {
    const response = await apiClient.put("/auth/roles/permissions/", {
      agency_id: agencyId,
      role,
      permissions,
    });
    return response.data;
  },
};
